<template>
  <div :class="$style['icon-container']" @click="$emit('click')">
    <div :class="{ [$style['icon-wrapper']]: true, [$style.pointer]: pointer }">
      <!-- SVG ICONS -->
      <symbol id="arrow-down">
        <path
          d="M0.826172 0.741959L6.82617 6.77306L12.8262 0.741959"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="arrow-up">
        <path
          d="M8.82617 17.7731L14.8262 11.742L20.8262 17.7731"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="left">
        <path d="M11.67 2.27L9.9 0.5L0 10.4L9.9 20.3L11.67 18.53L3.54 10.4L11.67 2.27Z"
              fill="#BBBFC9"
        />
      </symbol>
      <symbol id="right">
        <path d="M-1.90735e-06 2.27L1.77 0.5L11.67 10.4L1.77 20.3L-1.90735e-06 18.53L8.13 10.4L-1.90735e-06 2.27Z"
              fill="#BBBFC9"
        />
      </symbol>
      <symbol id="route-point">
        <path
          d="M23.3799 12.1951C23.3799 6.01055 18.2826 0.995969 11.9908 0.986464C5.77501 0.976986 0.663795 5.90944 0.567199 12.0181C0.514545 15.0599 1.72639 17.9912 3.92287 20.1352H3.90944L11.2839 27.9351C11.4754 28.1376 11.7443 28.2523 12.0256 28.2514C12.3069 28.2506 12.5751 28.1342 12.7652 27.9305L20.0368 20.1352H20.0234C22.1752 18.0344 23.3836 15.1758 23.3799 12.1951Z"
        />
        <path
          d="M11.994 19.0937C15.7998 19.0937 18.8849 16.0653 18.8849 12.3295C18.8849 8.59375 15.7998 5.56531 11.994 5.56531C8.18822 5.56531 5.10303 8.59375 5.10303 12.3295C5.10303 16.0653 8.18822 19.0937 11.994 19.0937Z"
          fill="white"
        />
      </symbol>
      <symbol id="folder">
        <path
          d="M18 2H10L8 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2ZM12 12H4V10H12V12ZM16 8H4V6H16V8Z"
        />
      </symbol>
      <symbol id="map">
        <path
          d="M20.5 3L20.34 3.03L15 5.1L9 3L3.36 4.9C3.15 4.97 3 5.15 3 5.38V20.5C3 20.78 3.22 21 3.5 21L3.66 20.97L9 18.9L15 21L20.64 19.1C20.85 19.03 21 18.85 21 18.62V3.5C21 3.22 20.78 3 20.5 3ZM10 5.47L14 6.87V18.53L10 17.13V5.47ZM5 6.46L8 5.45V17.15L5 18.31V6.46ZM19 17.54L16 18.55V6.86L19 5.7V17.54Z"
        />
      </symbol>
      <symbol id="location">
        <path
          d="M12 4C13.93 4 17 5.4 17 9.15C17 11.31 15.28 13.82 12 16.47C8.72 13.82 7 11.3 7 9.15C7 5.4 10.07 4 12 4ZM12 2C8.73 2 5 4.46 5 9.15C5 12.27 7.33 15.56 12 19C16.67 15.56 19 12.27 19 9.15C19 4.46 15.27 2 12 2Z"
        />
        <path
          d="M12 7C10.9 7 10 7.9 10 9C10 10.1 10.9 11 12 11C12.5304 11 13.0391 10.7893 13.4142 10.4142C13.7893 10.0391 14 9.53043 14 9C14 8.46957 13.7893 7.96086 13.4142 7.58579C13.0391 7.21071 12.5304 7 12 7ZM5 20H19V22H5V20Z"
        />
      </symbol>
      <symbol id="task">
        <path
          d="M19 5V9H4V5H19ZM19 15V19H4V15H19ZM20 3H3C2.45 3 2 3.45 2 4V10C2 10.55 2.45 11 3 11H20C20.55 11 21 10.55 21 10V4C21 3.45 20.55 3 20 3ZM20 13H3C2.45 13 2 13.45 2 14V20C2 20.55 2.45 21 3 21H20C20.55 21 21 20.55 21 20V14C21 13.45 20.55 13 20 13Z"
        />
      </symbol>
      <symbol id="workers">
        <path
          d="M16.67 13.13C18.04 14.06 19 15.32 19 17V20H23V17C23 14.82 19.43 13.53 16.67 13.13Z"
        />
        <path
          d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
        />
        <path
          d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z"
        />
        <path
          d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
        />
      </symbol>
      <symbol id="settings">
        <path
          d="M2 12C2 11.135 2.11 10.297 2.316 9.496C2.86847 9.52504 3.4182 9.40075 3.90444 9.13687C4.39068 8.87299 4.79448 8.47979 5.07121 8.00074C5.34793 7.5217 5.48681 6.97546 5.47247 6.42242C5.45814 5.86938 5.29117 5.33107 4.99 4.867C6.19894 3.67757 7.69079 2.8155 9.325 2.362C9.57599 2.85547 9.95864 3.26987 10.4306 3.55931C10.9025 3.84875 11.4454 4.00195 11.999 4.00195C12.5526 4.00195 13.0955 3.84875 13.5674 3.55931C14.0394 3.26987 14.422 2.85547 14.673 2.362C16.3072 2.8155 17.7991 3.67757 19.008 4.867C18.7065 5.33115 18.5393 5.86967 18.5248 6.42296C18.5104 6.97626 18.6493 7.52276 18.9262 8.00201C19.2031 8.48126 19.6071 8.87457 20.0937 9.13841C20.5802 9.40226 21.1303 9.52637 21.683 9.497C21.889 10.297 21.999 11.135 21.999 12C21.999 12.865 21.889 13.703 21.683 14.504C21.1305 14.4748 20.5806 14.5989 20.0942 14.8627C19.6078 15.1265 19.2039 15.5197 18.927 15.9988C18.6502 16.4779 18.5112 17.0242 18.5255 17.5773C18.5398 18.1304 18.7068 18.6689 19.008 19.133C17.7991 20.3224 16.3072 21.1845 14.673 21.638C14.422 21.1445 14.0394 20.7301 13.5674 20.4407C13.0955 20.1512 12.5526 19.998 11.999 19.998C11.4454 19.998 10.9025 20.1512 10.4306 20.4407C9.95864 20.7301 9.57599 21.1445 9.325 21.638C7.69079 21.1845 6.19894 20.3224 4.99 19.133C5.29151 18.6688 5.45873 18.1303 5.47317 17.577C5.48761 17.0237 5.3487 16.4772 5.07181 15.998C4.79492 15.5187 4.39085 15.1254 3.90431 14.8616C3.41776 14.5977 2.8677 14.4736 2.315 14.503C2.11 13.704 2 12.866 2 12ZM6.804 15C7.434 16.091 7.614 17.346 7.368 18.524C7.776 18.814 8.21 19.065 8.665 19.274C9.58167 18.4528 10.7693 17.9991 12 18C13.26 18 14.438 18.471 15.335 19.274C15.79 19.065 16.224 18.814 16.632 18.524C16.3794 17.32 16.5803 16.0651 17.196 15C17.8106 13.9344 18.797 13.1332 19.966 12.75C20.0122 12.2511 20.0122 11.7489 19.966 11.25C18.7966 10.8671 17.8099 10.0658 17.195 9C16.5793 7.93493 16.3784 6.68004 16.631 5.476C16.2231 5.18592 15.7889 4.93482 15.334 4.726C14.4176 5.54693 13.2303 6.00061 12 6C10.7693 6.00085 9.58167 5.54716 8.665 4.726C8.21013 4.93482 7.77589 5.18593 7.368 5.476C7.62056 6.68004 7.41972 7.93493 6.804 9C6.18937 10.0656 5.20298 10.8668 4.034 11.25C3.98775 11.7489 3.98775 12.2511 4.034 12.75C5.20335 13.1329 6.19013 13.9342 6.805 15H6.804ZM12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15ZM12 13C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13Z"
        />
      </symbol>
      <symbol id="logout">
        <path
          d="M6 18H8V20H20V4H8V6H6V3C6 2.73478 6.10536 2.48043 6.29289 2.29289C6.48043 2.10536 6.73478 2 7 2H21C21.2652 2 21.5196 2.10536 21.7071 2.29289C21.8946 2.48043 22 2.73478 22 3V21C22 21.2652 21.8946 21.5196 21.7071 21.7071C21.5196 21.8946 21.2652 22 21 22H7C6.73478 22 6.48043 21.8946 6.29289 21.7071C6.10536 21.5196 6 21.2652 6 21V18ZM8 11H15V13H8V16L3 12L8 8V11Z"
        />
      </symbol>
      <symbol id="burger">
        <rect x="4" y="7" width="16" height="2" />
        <rect x="4" y="11" width="16" height="2" />
        <rect x="4" y="15" width="16" height="2" />
      </symbol>
      <symbol id="folder">
        <path
          d="M19.2 20H4.8C3.80589 20 3 19.2041 3 18.2222V5.77778C3 4.79594 3.80589 4 4.8 4H10.2C10.4387 4 10.6676 4.09373 10.8363 4.26044L12.3726 5.77778H19.2C20.1941 5.77778 21 6.57372 21 7.55556V18.2222C21 19.2041 20.1941 20 19.2 20ZM4.8 7.55556V18.2222H19.2V7.55556H4.8Z"
        />
      </symbol>
      <symbol id="clock">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM11 7H12.5V12.25L17 14.92L16.25 16.15L11 13V7Z"
        />
      </symbol>
      <symbol id="edit">
        <path
          d="M4.88144 20C4.63516 19.9996 4.40039 19.8957 4.23439 19.7137C4.06534 19.5332 3.98134 19.2891 4.00349 19.0428L4.21859 16.6769L14.1552 6.74108L17.2605 9.84636L7.32653 19.7813L4.96134 19.9965C4.93412 19.9991 4.9069 20 4.88144 20ZM17.8804 9.22548L14.7759 6.1202L16.6381 4.25756C16.8028 4.09266 17.0262 4 17.2592 4C17.4922 4 17.7157 4.09266 17.8804 4.25756L19.7425 6.1202C19.9074 6.28492 20 6.50844 20 6.74152C20 6.9746 19.9074 7.19812 19.7425 7.36284L17.8813 9.22461L17.8804 9.22548Z"
        />
      </symbol>
      <symbol id="delete">
        <path
          d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z"
        />
      </symbol>
      <symbol id="list">
        <path
          d="M20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V3C3 2.73478 3.10536 2.48043 3.29289 2.29289C3.48043 2.10536 3.73478 2 4 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22ZM19 20V4H5V20H19ZM8 7H16V9H8V7ZM8 11H16V13H8V11ZM8 15H13V17H8V15Z"
        />
      </symbol>
      <symbol id="rename">
        <rect width="24" height="24" fill="white" />
        <path
          d="M18.41 5.8L17.2 4.59C16.42 3.81 15.15 3.81 14.37 4.59L11.69 7.27L3 15.96V20H7.04L15.78 11.26L18.41 8.63C19.2 7.85 19.2 6.58 18.41 5.8ZM6.21 18H5V16.79L13.66 8.13L14.87 9.34L6.21 18ZM11 20L15 16H21V20H11Z"
        />
      </symbol>
      <symbol id="more">
        <path
          d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z"
        />
      </symbol>
      <symbol id="hide">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.867512 11.7376C3.93499 7.34055 7.93864 5 11.9838 5C16.7251 5 20.782 8.08476 23.1641 11.7639L23.1656 11.7662C23.3476 12.049 23.4444 12.3783 23.4444 12.7147C23.4444 13.0503 23.348 13.3789 23.1667 13.6614C20.7855 17.3894 16.7538 20.4279 11.9838 20.4279C7.16341 20.4279 3.20831 17.3948 0.833485 13.6784C0.647234 13.389 0.550637 13.051 0.555866 12.7069C0.56111 12.3617 0.668544 12.0259 0.864591 11.7418L0.867501 11.7376L0.867512 11.7376ZM2.60804 12.7395C4.74777 16.0107 8.10749 18.4279 11.9838 18.4279C15.8193 18.4279 19.2533 15.9954 21.3967 12.7156C19.2435 9.46756 15.782 7 11.9838 7C8.79942 7 5.39151 8.82181 2.60804 12.7395Z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.9996 9.98396C10.4919 9.98396 9.26965 11.2062 9.26965 12.7139C9.26965 14.2217 10.4919 15.4439 11.9996 15.4439C13.5074 15.4439 14.7296 14.2217 14.7296 12.7139C14.7296 11.2062 13.5074 9.98396 11.9996 9.98396ZM7.26965 12.7139C7.26965 10.1016 9.38734 7.98396 11.9996 7.98396C14.6119 7.98396 16.7296 10.1016 16.7296 12.7139C16.7296 15.3262 14.6119 17.4439 11.9996 17.4439C9.38734 17.4439 7.26965 15.3262 7.26965 12.7139Z"
        />
        <rect
          x="5.32601"
          y="2.50584"
          width="2.56408"
          height="23"
          rx="1.28204"
          transform="rotate(-27.3959 5.32601 2.50584)"
          stroke="white"
        />
      </symbol>
      <symbol id="redo">
        <path
          d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8C6.85004 8 2.92004 11.03 1.54004 15.22L3.90004 16C4.95004 12.81 7.95004 10.5 11.5 10.5C13.45 10.5 15.23 11.22 16.62 12.38L13 16H22V7L18.4 10.6Z"
        />
      </symbol>
      <symbol id="undo">
        <path
          d="M12.5 8C9.85 8 7.45 8.99 5.6 10.6L2 7V16H11L7.38 12.38C8.77 11.22 10.54 10.5 12.5 10.5C16.04 10.5 19.05 12.81 20.1 16L22.47 15.22C21.08 11.03 17.15 8 12.5 8Z"
        />
      </symbol>
      <symbol id="next">
        <path
          d="M0.634314 1.71841L2.11765 0.243408L10.3593 8.49341L2.10931 16.7434L0.634314 15.2684L7.40931 8.49341L0.634314 1.71841Z"
        />
      </symbol>
      <symbol id="workers-list">
        <path
          d="M7 12.7663H11V10.7663H7V12.7663ZM0 0.766296V2.7663H18V0.766296H0ZM3 7.7663H15V5.7663H3V7.7663Z"
          fill="#1C2A4A"
        />
      </symbol>
      <symbol id="save">
        <g clip-path="url(#clip0)">
          <path
            d="M12 15.5556L15.6364 12H12.9091V4H11.0909V12H8.36364L12 15.5556ZM20.1818 4H14.7273V5.76889H20.1818V18.24H3.81818V5.76889H9.27273V4H3.81818C2.81818 4 2 4.8 2 5.77778V18.2222C2 19.2 2.81818 20 3.81818 20H20.1818C21.1818 20 22 19.2 22 18.2222V5.77778C22 4.8 21.1818 4 20.1818 4Z"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </symbol>
      <symbol id="link-arrow">
        <path
          d="M6.99998 6.33333V4.33333L9.66665 7L6.99998 9.66666V7.66666H4.33331V6.33333H6.99998ZM6.99998 0.333328C10.68 0.333328 13.6666 3.31999 13.6666 7C13.6666 10.68 10.68 13.6667 6.99998 13.6667C3.31998 13.6667 0.333313 10.68 0.333313 7C0.333313 3.31999 3.31998 0.333328 6.99998 0.333328ZM6.99998 12.3333C9.94665 12.3333 12.3333 9.94666 12.3333 7C12.3333 4.05333 9.94665 1.66666 6.99998 1.66666C4.05331 1.66666 1.66665 4.05333 1.66665 7C1.66665 9.94666 4.05331 12.3333 6.99998 12.3333Z"
        />
      </symbol>
      <symbol id="back">
        <path
          d="M9.86245 2.225L8.37912 0.75L0.137451 9L8.38745 17.25L9.86245 15.775L3.08745 9L9.86245 2.225Z"
        />
      </symbol>
      <symbol id="done">
        <path
          d="M6.00039 11.1996L1.80039 6.99961L0.400391 8.39961L6.00039 13.9996L18.0004 1.99961L16.6004 0.599609L6.00039 11.1996Z"
        />
      </symbol>
      <symbol id="cross">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30 5.60205C16.0203 5.60205 4.6875 16.9348 4.6875 30.9146C4.6875 44.8942 16.0203 56.2271 30 56.2271C43.9797 56.2271 55.3125 44.8942 55.3125 30.9146C55.3125 16.9348 43.9797 5.60205 30 5.60205Z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M38.3101 38.5854L37.6708 39.2246C37.1413 39.7542 36.2827 39.7542 35.7531 39.2246L21.6899 25.1614C21.1603 24.6319 21.1603 23.7733 21.6899 23.2437L22.3291 22.6045C22.8587 22.075 23.7173 22.075 24.2468 22.6045L38.3101 36.6677C38.8396 37.1973 38.8396 38.0558 38.3101 38.5854Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.6899 38.5854L22.3292 39.2246C22.8587 39.7542 23.7173 39.7542 24.2469 39.2246L38.3101 25.1614C38.8396 24.6319 38.8396 23.7733 38.3101 23.2437L37.6709 22.6045C37.1413 22.075 36.2827 22.075 35.7532 22.6045L21.6899 36.6677C21.1603 37.1973 21.1603 38.0558 21.6899 38.5854Z"
          fill="white"
        />
      </symbol>
      <symbol id="search">
        <path
          d="M13.4286 13.4286L10.3214 10.3214M12 6.28573C12 9.44164 9.44164 12 6.28573 12C3.12981 12 0.571442 9.44164 0.571442 6.28573C0.571442 3.12981 3.12981 0.571442 6.28573 0.571442C9.44164 0.571442 12 3.12981 12 6.28573Z"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="filter">
        <path
          d="M15.1429 0.571442H0.857147L6.57143 7.32858V12.7143L9.42858 14.1429V7.32858L15.1429 0.571442Z"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="calendar">
        <path
          d="M6 9H4V11H6V9ZM10 9H8V11H10V9ZM14 9H12V11H14V9ZM16 2H15V0H13V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 18H2V7H16V18Z"
        />
        <path d="M4 13H6V15H4V13Z" />
        <path d="M8 13H10V15H8V13Z" />
        <path d="M12 13H14V15H12V13Z" />
      </symbol>
      <symbol id="users">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.9937 3.41473C13.6117 3.41473 3.57397 13.4883 3.57397 25.9146C3.57397 38.3408 13.6117 48.4144 25.9937 48.4144C38.3753 48.4144 48.4135 38.3408 48.4135 25.9146C48.4135 13.4883 38.3753 3.41473 25.9937 3.41473Z"
          fill="#597EF7"
        />
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="3"
          y="3"
          width="46"
          height="46"
        >
          <path
            d="M25.9935 3.53925C13.6115 3.53925 3.57373 13.6129 3.57373 26.0391C3.57373 38.4657 13.6115 48.5389 25.9935 48.5389C38.3755 48.5389 48.4129 38.4657 48.4129 26.0391"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M40.2314 46.2121C43.8012 46.2121 47.0431 44.8399 49.4922 42.6076C48.864 38.1105 45.026 31.9962 40.3713 31.9962C35.6395 31.9962 31.7452 38.225 31.2166 42.8318C33.6355 44.9326 36.7816 46.2121 40.2314 46.2121Z"
            fill="#A8C1EF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M45.7581 27.3483C45.7581 30.3433 43.3392 32.7713 40.3548 32.7713C37.37 32.7713 34.9507 30.3433 34.9507 27.3483C34.9507 24.3532 37.37 21.9253 40.3548 21.9253C43.3392 21.9253 45.7581 24.3532 45.7581 27.3483Z"
            fill="#E4EBF7"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.02222 42.3018C4.44115 44.4022 7.58722 45.6821 11.0371 45.6821C14.6069 45.6821 17.8487 44.3099 20.2979 42.0777C19.6696 37.5805 15.8317 31.9964 11.1769 31.9964C6.44518 31.9964 2.5509 37.695 2.02222 42.3018Z"
            fill="#A8C1EF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.5638 27.3483C16.5638 30.3433 14.1448 32.7713 11.1604 32.7713C8.17528 32.7713 5.75635 30.3433 5.75635 27.3483C5.75635 24.3532 8.17528 21.9253 11.1604 21.9253C14.1448 21.9253 16.5638 24.3532 16.5638 27.3483Z"
            fill="#E4EBF7"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.9236 44.4103C16.4784 47.4972 21.1025 49.3777 26.1725 49.3777C31.418 49.3777 36.1827 47.3615 39.7824 44.0812C38.8595 37.4717 33.2186 29.6691 26.3783 29.6691C19.4237 29.6691 13.7001 37.6397 12.9236 44.4103Z"
            fill="#CCD7EE"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M34.2947 24.0752C34.2947 28.477 30.7391 32.0453 26.3533 32.0453C21.9667 32.0453 18.4111 28.477 18.4111 24.0752C18.4111 19.6733 21.9667 16.1054 26.3533 16.1054C30.7391 16.1054 34.2947 19.6733 34.2947 24.0752Z"
            fill="white"
          />
        </g>
      </symbol>
      <symbol id="locations">
        <path
          d="M45.5102 17.9766H6.54062C5.73291 17.9766 5.07812 18.6313 5.07812 19.4391V45.5102C5.07812 46.3179 5.73291 46.9727 6.54062 46.9727H45.5102C46.3179 46.9727 46.9727 46.3179 46.9727 45.5102V19.4391C46.9727 18.6313 46.3179 17.9766 45.5102 17.9766Z"
          fill="#E4EBF7"
        />
        <path
          d="M5.07812 26L13.1523 32.4466L5.07812 42.0977V26Z"
          fill="#FAAD14"
        />
        <path
          d="M5.07812 19.6394L20.6058 32.3477L33.4141 17.9258H6.28584C5.61884 17.9258 5.07812 18.4674 5.07812 19.1354V19.6394Z"
          fill="#FF7946"
        />
        <path
          d="M33.8434 41.42C32.4491 43.4857 31.6576 45.5514 31.2305 46.9727H45.7143C46.3812 46.9727 46.9219 46.4313 46.9219 45.7635V34.125C44.0036 34.3265 41.4028 35.0788 39.1703 36.3726C37.0761 37.5848 35.2839 39.2837 33.8434 41.42Z"
          fill="#7CB305"
        />
        <path
          d="M37.6025 33.5559C35.0812 35.0143 32.933 37.0405 31.2162 39.5796C29.2804 42.4431 28.3465 45.2965 27.9297 46.9219H31.2721C31.6995 45.5037 32.4914 43.4433 33.8865 41.3795C35.3279 39.2472 37.1212 37.5514 39.2165 36.3395C41.4503 35.049 44.0527 34.2972 46.9727 34.0976V30.875C43.4707 31.0817 40.3271 31.9814 37.6025 33.5559Z"
          fill="white"
        />
        <path
          d="M14.7266 40.5234C11.1816 40.5234 8.30109 43.3811 8.27734 46.9219H21.1758C21.152 43.3811 18.2716 40.5234 14.7266 40.5234Z"
          fill="#597EF7"
        />
        <path
          d="M39.6602 18.752C39.6602 11.2072 33.556 5.08971 26.0216 5.07811C18.5782 5.06655 12.4575 11.0839 12.3418 18.536C12.2788 22.2468 13.73 25.823 16.3603 28.4385H16.3442L25.1752 37.9538C25.4044 38.2009 25.7264 38.3409 26.0633 38.3398C26.4002 38.3387 26.7213 38.1968 26.949 37.9483L35.6568 28.4385H35.6407C38.2175 25.8756 39.6646 22.3883 39.6602 18.752Z"
          fill="#597EF7"
        />
        <path
          d="M26.0254 27.168C30.5828 27.168 34.2773 23.4734 34.2773 18.916C34.2773 14.3586 30.5828 10.6641 26.0254 10.6641C21.468 10.6641 17.7734 14.3586 17.7734 18.916C17.7734 23.4734 21.468 27.168 26.0254 27.168Z"
          fill="white"
        />
      </symbol>
      <symbol id="tasks">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.8622 22.549C14.5068 22.549 12.5973 20.6395 12.5973 18.2841C12.5973 15.9287 14.5068 14.0192 16.8622 14.0192C19.2176 14.0192 21.1271 15.9287 21.1271 18.2841C21.1271 20.6395 19.2176 22.549 16.8622 22.549ZM29.6619 20.2133V16.3548L26.6208 15.5821C26.3978 14.7747 26.0774 14.0079 25.6728 13.2949L27.2771 10.5975L24.5487 7.86915L21.8513 9.4735C21.1384 9.06887 20.3715 8.74846 19.5642 8.52541L18.7914 5.48441H14.9329L14.1602 8.52541C13.3528 8.74846 12.586 9.06887 11.873 9.4735L9.17563 7.86915L6.44724 10.5975L8.05155 13.2949C7.64701 14.0079 7.32656 14.7748 7.1035 15.5821L4.0625 16.3548V20.2133L7.1035 20.9861C7.32656 21.7934 7.64701 22.5603 8.05155 23.2732L6.44724 25.9706L9.17563 28.699L11.873 27.0947C12.586 27.4993 13.3528 27.8197 14.1602 28.0428L14.9329 31.0838H18.7914L19.5642 28.0428C20.3715 27.8197 21.1384 27.4993 21.8513 27.0947L24.5487 28.699L27.2771 25.9706L25.6728 23.2732C26.0774 22.5603 26.3978 21.7934 26.6208 20.9861L29.6619 20.2133Z"
          fill="#597EF7"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M36.0296 38.45C33.8413 38.45 32.0674 36.6761 32.0674 34.4878C32.0674 32.2995 33.8413 30.5255 36.0296 30.5255C38.2179 30.5255 39.9919 32.2995 39.9919 34.4878C39.9919 36.6761 38.2179 38.45 36.0296 38.45ZM47.9211 36.2801V32.6954L45.0959 31.9775C44.8887 31.2274 44.591 30.515 44.2151 29.8527L45.7056 27.3466L43.1708 24.8118L40.6648 26.3024C40.0024 25.9265 39.29 25.6287 38.5399 25.4215L37.822 22.5963H34.2372L33.5194 25.4215C32.7693 25.6287 32.0569 25.9265 31.3945 26.3024L28.8885 24.8118L26.3537 27.3466L27.8442 29.8527C27.4683 30.515 27.1706 31.2274 26.9634 31.9775L24.1382 32.6954V36.2801L26.9634 36.998C27.1706 37.7481 27.4683 38.4605 27.8442 39.1229L26.3537 41.6289L28.8885 44.1637L31.3945 42.6732C32.0569 43.0491 32.7693 43.3468 33.5194 43.554L34.2372 46.3793H37.822L38.5399 43.554C39.29 43.3468 40.0024 43.0491 40.6648 42.6732L43.1708 44.1637L45.7056 41.6289L44.2151 39.1229C44.591 38.4605 44.8887 37.7481 45.0959 36.998L47.9211 36.2801Z"
          fill="#253368"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M37.3125 17.1307L32.6127 16.2234L37.5845 10.5853C37.1412 10.5144 36.6868 10.477 36.2236 10.477C31.5057 10.477 27.6812 14.3015 27.6812 19.0194C27.6812 23.7372 31.5057 27.5618 36.2236 27.5618C40.9415 27.5618 44.766 23.7372 44.766 19.0194C44.766 18.6873 44.7464 18.3598 44.7096 18.0376L37.3125 17.1307Z"
          fill="#A3B5D6"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M37.3121 17.1307L28.4728 15.4243C27.9649 16.5171 27.6808 17.735 27.6808 19.0194C27.6808 20.1757 27.9111 21.2781 28.3274 22.284L9.36994 39.8707C8.21414 43.5113 11.7013 46.9136 15.3124 45.6685L15.5643 45.5816L33.0211 26.9407C34.01 27.3409 35.0908 27.5618 36.2232 27.5618C40.9411 27.5618 44.7657 23.7373 44.7657 19.0194C44.7657 16.4569 43.6371 14.1583 41.8503 12.5926L37.3121 17.1307Z"
          fill="#CCD7EE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.3108 28.7215L26.4521 26.8628L28.3108 25.0041L30.1695 26.8628L28.3108 28.7215Z"
          fill="#A3B5D6"
        />
      </symbol>
      <symbol id="rp_success">
        <path
          d="M246.805 97.4883H35.4703C31.09 97.4883 27.5391 101.039 27.5391 105.42V246.805C27.5391 251.185 31.09 254.736 35.4703 254.736H246.805C251.185 254.736 254.736 251.185 254.736 246.805V105.42C254.736 101.039 251.185 97.4883 246.805 97.4883Z"
          fill="#E4EBF7"
        />
        <path
          d="M27.5391 141L71.3262 175.96L27.5391 228.299V141Z"
          fill="#FAAD14"
        />
        <path
          d="M27.5391 106.506L111.747 175.424L181.207 97.2129H34.0886C30.4714 97.2129 27.5391 100.15 27.5391 103.773V106.506Z"
          fill="#FF7946"
        />
        <path
          d="M183.535 224.624C175.974 235.826 171.682 247.028 169.365 254.736H247.912C251.529 254.736 254.461 251.8 254.461 248.179V185.062C238.635 186.155 224.53 190.235 212.423 197.251C201.067 203.825 191.347 213.039 183.535 224.624Z"
          fill="#7CB305"
        />
        <path
          d="M203.921 181.976C190.248 189.885 178.598 200.873 169.288 214.643C158.79 230.172 153.725 245.647 151.465 254.461H169.591C171.909 246.77 176.204 235.597 183.769 224.404C191.586 212.841 201.311 203.644 212.674 197.072C224.788 190.074 238.901 185.996 254.736 184.914V167.438C235.745 168.558 218.697 173.437 203.921 181.976Z"
          fill="white"
        />
        <path
          d="M79.8633 219.762C60.6385 219.761 45.0175 235.259 44.8887 254.461H114.838C114.709 235.259 99.0881 219.761 79.8633 219.762Z"
          fill="#597EF7"
        />
        <path
          d="M215.08 101.694C215.08 60.7777 181.977 27.6019 141.117 27.5391C100.751 27.4764 67.5579 60.1087 66.9306 100.522C66.5887 120.646 74.4586 140.04 88.7229 154.224H88.6356L136.527 205.827C137.77 207.167 139.516 207.926 141.343 207.92C143.17 207.914 144.912 207.144 146.147 205.797L193.37 154.224H193.282C207.256 140.325 215.104 121.413 215.08 101.694Z"
          fill="#597EF7"
        />
        <path
          d="M141.138 147.334C165.853 147.334 185.889 127.298 185.889 102.583C185.889 77.8677 165.853 57.832 141.138 57.832C116.422 57.832 96.3867 77.8677 96.3867 102.583C96.3867 127.298 116.422 147.334 141.138 147.334Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M141.324 68.5146C122.594 68.5146 107.411 83.698 107.411 102.428C107.411 121.157 122.594 136.341 141.324 136.341C160.054 136.341 175.237 121.157 175.237 102.428C175.237 83.698 160.054 68.5146 141.324 68.5146Z"
          fill="#7CB305"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M135.859 113.948L133.718 111.807L154.466 90.9833C155.175 90.2738 156.326 90.2738 157.035 90.9833L157.892 91.8397C158.601 92.5492 158.601 93.6995 157.892 94.409L138.429 113.948C137.719 114.657 136.569 114.657 135.859 113.948Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M140.566 111.807L138.425 113.948C137.715 114.657 136.565 114.657 135.856 113.948L127.33 105.422C126.62 104.712 126.62 103.562 127.33 102.853L128.186 101.996C128.896 101.287 130.046 101.287 130.756 101.996L140.566 111.807Z"
          fill="white"
        />
      </symbol>
      <symbol id="rp_proccess">
        <path
          d="M246.805 97.4883H35.4703C31.09 97.4883 27.5391 101.039 27.5391 105.42V246.805C27.5391 251.185 31.09 254.736 35.4703 254.736H246.805C251.185 254.736 254.736 251.185 254.736 246.805V105.42C254.736 101.039 251.185 97.4883 246.805 97.4883Z"
          fill="#E4EBF7"
        />
        <path
          d="M27.5391 141L71.3262 175.96L27.5391 228.299V141Z"
          fill="#FAAD14"
        />
        <path
          d="M27.5391 106.506L111.747 175.424L181.207 97.2129H34.0886C30.4714 97.2129 27.5391 100.15 27.5391 103.773V106.506Z"
          fill="#FF7946"
        />
        <path
          d="M183.535 224.624C175.974 235.826 171.682 247.028 169.365 254.736H247.912C251.529 254.736 254.461 251.8 254.461 248.179V185.062C238.635 186.155 224.53 190.235 212.423 197.251C201.067 203.825 191.347 213.039 183.535 224.624Z"
          fill="#7CB305"
        />
        <path
          d="M203.921 181.976C190.248 189.885 178.598 200.873 169.288 214.643C158.79 230.172 153.725 245.647 151.465 254.461H169.591C171.909 246.77 176.204 235.597 183.769 224.404C191.586 212.841 201.311 203.644 212.674 197.072C224.788 190.074 238.901 185.996 254.736 184.914V167.438C235.745 168.558 218.697 173.437 203.921 181.976Z"
          fill="white"
        />
        <path
          d="M79.8633 219.762C60.6385 219.761 45.0175 235.259 44.8887 254.461H114.838C114.709 235.259 99.0881 219.761 79.8633 219.762Z"
          fill="#597EF7"
        />
        <path
          d="M215.08 101.694C215.08 60.7777 181.977 27.6019 141.117 27.5391C100.751 27.4764 67.5579 60.1087 66.9306 100.522C66.5887 120.646 74.4586 140.04 88.7229 154.224H88.6356L136.527 205.827C137.77 207.167 139.516 207.926 141.343 207.92C143.17 207.914 144.912 207.144 146.147 205.797L193.37 154.224H193.282C207.256 140.325 215.104 121.413 215.08 101.694Z"
          fill="#BBBFC9"
        />
        <path
          d="M141.138 147.334C165.853 147.334 185.889 127.298 185.889 102.583C185.889 77.8677 165.853 57.832 141.138 57.832C116.422 57.832 96.3867 77.8677 96.3867 102.583C96.3867 127.298 116.422 147.334 141.138 147.334Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M140.5 109.996C134.703 109.996 130.004 105.297 130.004 99.5C130.004 93.7033 134.703 89.0041 140.5 89.0041C146.297 89.0041 150.996 93.7033 150.996 99.5C150.996 105.297 146.297 109.996 140.5 109.996ZM172 104.248V94.7521L164.516 92.8505C163.967 90.8635 163.179 88.9762 162.183 87.2217L166.131 80.5834L159.417 73.8688L152.778 77.8172C151.024 76.8214 149.136 76.0328 147.15 75.4839L145.248 68H135.752L133.85 75.4839C131.863 76.0328 129.976 76.8214 128.222 77.8172L121.583 73.8688L114.869 80.5834L118.817 87.2217C117.822 88.9762 117.033 90.8636 116.484 92.8505L109 94.7521V104.248L116.484 106.15C117.033 108.136 117.822 110.024 118.817 111.778L114.869 118.417L121.583 125.131L128.222 121.183C129.976 122.179 131.863 122.967 133.85 123.516L135.752 131H145.248L147.15 123.516C149.136 122.967 151.024 122.179 152.778 121.183L159.417 125.131L166.131 118.417L162.183 111.778C163.179 110.024 163.967 108.136 164.516 106.15L172 104.248Z"
          fill="#597EF7"
        />
      </symbol>
      <symbol id="close-circle">
        <path d="M8.71434 5.28571L5.28577 8.71428M5.28577 5.28571L8.71434 8.71428M12.7143 6.99999C12.7143 10.1559 10.156 12.7143 7.00005 12.7143C3.84414 12.7143 1.28577 10.1559 1.28577 6.99999C1.28577 3.84408 3.84414 1.28571 7.00005 1.28571C10.156 1.28571 12.7143 3.84408 12.7143 6.99999Z"
              stroke="#1C2A4A"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="transparent"
        />
      </symbol>

      <svg
        v-if="svgIcons.includes(name) || svgIconsStroke.includes(name)"
        :viewBox="viewboxes[name] ? viewboxes[name] : viewboxes.default"
        :height="height"
        :fill="svgIcons.includes(name) ? fillColor : 'none'"
        :stroke="svgIconsStroke.includes(name) ? fillColor : 'none'"
      >
        <use :xlink:href="'#' + name" />
      </svg>
      <!-- ANT ICONS -->
      <AntIcon
        v-else-if="antIcons.includes(name)"
        :type="name"
        :style="{ color: fillColor, 'font-size': height + 'px' }"
      />
    </div>
  </div>
</template>

<script>
import { Icon as AntIcon } from "ant-design-vue";
export default {
  name: "Icon",
  components: { AntIcon },
  data() {
    return {
      svgIcons: [
        "arrow-down",
        "arrow-up",
        "left",
        "right",
        "route-point",
        "folder",
        "map",
        "settings",
        "location",
        "logout",
        "task",
        "workers",
        "burger",
        "folder",
        "clock",
        "edit",
        "delete",
        "list",
        "rename",
        "more",
        "hide",
        "redo",
        "undo",
        "save",
        "link-arrow",
        "back",
        "done",
        "cross",
        "calendar",
        "next",
        "filter",
        "workers-list",
        "users",
        "locations",
        "tasks",
        "rp_success",
        "rp_proccess",
        "close-circle"
      ],
      svgIconsStroke: ["search", "filter"],
      antIcons: ["plus", "loading"],
      viewboxes: {
        "route-point": "0 0 24 29",
        default: "0 0 23 23",
        done: "0 0 19 15",
        cross: "0 0 60 61",
        search: "0 0 14 14",
        filter: "0 0 16 15",
        users: "0 0 52 52",
        locations: "0 0 52 52",
        tasks: "0 0 52 52",
        rp_success: "0 0 282 282",
        rp_proccess: "0 0 282 282",
        "close-circle": "0 0 14 14",
      }
    };
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      require: true
    },
    fill: {
      type: String,
      default: null
    },
    height: {
      type: Number,
      default: 20
    },
    pointer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fillColor() {
      return this.fill ? this.fill : this.active ? "#2E92F8" : "#BBBFC9";
    }
  },
  methods: {}
};
</script>

<style lang="scss" module>
.icon-container {
  display: inline-block;
  .icon-wrapper {
    width: fit-content;
    display: flex;
    margin: 0 auto;
  }

  .pointer {
    cursor: pointer;
  }
}
</style>
